

import { Component, Vue } from 'vue-property-decorator';
import { PopupModule } from '~common-store/modules/popup';

@Component
export default class ActionReloader extends Vue {
    get lastExecuted() {
        return PopupModule.lastExecuted;
    }
}
